import { ParentDiv } from "../../styles/WrapperStyles";
import styled from "styled-components";
import BaseModel from "../../BaseModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
`;

const Th = styled.th`
    font-family: 'Gilory-Bold';
    font-size: 15px;
    font-weight: 800;
    color: #484848;
    text-align: center;
    padding: 5px;
    border: 1px solid #000;
`;

const Td = styled.td`
    font-family: 'Gilory-Semi';
    font-size: 14px;
    color: #9b9b9b;
    text-align: center;
    padding: 5px;
    border: 1px solid #000;
`;

const LineViewItem = styled.tr`
    td {
        height: 1px;
        background: #000000;
    }
`;

const backButtons = {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
    color: "#000",
    cursor: "pointer",
    fontSize: "14px",
    fontFamily: "Gilory-Semi",
    "&:hover": {
        color: "#000",
    },

};

const columnLabels = {
    ref_reviewed: "Ref Reviewed",
};

const StatsModal = (props) => {
    const handleDateChange = (date) => {
        props.handleStatsDateChange(date);
    };

    return (
        <ParentDiv style={{ padding: "20px", width: "100%" }}>
            <button style={backButtons} onClick={props.handleClose}>Close</button>
            <>Date: </>
            <DatePicker
                selected={props.startDate}
                onChange={handleDateChange}
                dateFormat={'dd-MM-yyyy'}
            />
            <br /><br />
            <Table>
                <thead>
                    <tr>
                        <Th>Name</Th>
                        {props.columnNames.map((col) => (
                            <Th key={col}>{columnLabels[col] || col}</Th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {props.list.map((item, index) => (
                        item.seperator ? (
                            <LineViewItem key={"seperator" + index}>
                                <td colSpan={props.columnNames.length + 1}></td>
                            </LineViewItem>
                        ) : (
                            <tr key={item.name}>
                                <Td>{item.name}</Td>
                                {props.columnNames.map((col) => (
                                    <Td key={item.name + col}>{item.data[col]}</Td>
                                ))}
                            </tr>
                        )
                    ))}
                </tbody>
            </Table>
        </ParentDiv>
    );
};

export default StatsModal;
